import { useNavigate, useParams } from "react-router-dom";
import { useActivateSmsCampaigns } from "../../../../hooks/api/mutations/useMarketing";
import { pathConstants } from "../../../../routes/pathContants";
import { useContext, useState } from "react";
import { ToastContext } from "../../../../hooks/context";

export const useSmsCampaignReviewForm = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const triggerToast = useContext(ToastContext);
  const [isRecipient, setisRecipient] = useState(false);

  const { mutate: activateCampaign, isLoading } = useActivateSmsCampaigns();
  const handleActivateCampaign = () => {
    activateCampaign(
      { id },
      {
        onSuccess: () => {
          triggerToast("Sms campaign activated successfully", "success");
          navigate(pathConstants.MARKETING_SMS_CAMPAIGNS_CUSTOM);
        },
      },
    );
  };

  return {
    isLoading,
    isRecipient,
    setisRecipient,
    handleActivateCampaign,
    navigate,
  };
};
